/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_4_DescInputs */

const en_mk_studio_4_desc = /** @type {(inputs: Mk_Studio_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRD, wiki, evidence log, overrides, estimate vs actual, deploy and security notes — one file.`)
};

const id_mk_studio_4_desc = /** @type {(inputs: Mk_Studio_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRD, wiki, log bukti, override, estimasi vs aktual, catatan deploy dan keamanan — satu berkas.`)
};

/**
* | output |
* | --- |
* | "PRD, wiki, evidence log, overrides, estimate vs actual, deploy and security notes — one file." |
*
* @param {Mk_Studio_4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_4_desc = /** @type {((inputs?: Mk_Studio_4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_4_desc(inputs)
	return en_mk_studio_4_desc(inputs)
});